<!--
 * @Description: 首页/审核结果
 * @Author: yingbin
 * @Date: 2019-08-27 17:29:49
 * @LastEditTime: 2019-09-09 18:39:47
 * @LastEditors: yingbin
 -->
<template>
  <div class="examineResult">
    <el-table :data="tableData" style="width: 100%">
      <el-table-column type="index" align="center" width="100" label="序号"></el-table-column>
      <el-table-column prop="auditName" label="名称" width="200"></el-table-column>
      <el-table-column prop="applyTime" label="申请时间" width="200"></el-table-column>
      <el-table-column prop="auditTime" label="审核时间" width="200"></el-table-column>
      <el-table-column prop="auditResult" label="审核结果" width="100"></el-table-column>
      <el-table-column prop="remark" label="原因备注" width="200"></el-table-column>
    </el-table>
    <div class="bottom">
      <span>显示第 1 到第 {{pageSize}} 条记录，总共 {{table_total}} 条记录每页显示 {{pageSize}}条记录</span>
      <el-pagination
        :page-size="page_size"
        @size-change="changeSizes"
        :page-sizes="[10, 20, 50, 100]"
        @current-change="currentPage"
        layout="sizes,prev, pager, next, jumper"
        :total="table_total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import company from "../../apis/company_apis";
export default {
  data() {
    return {
      pageSize: 10,
      table_total: 0,
      page_size: 1,
      tableData: []
    };
  },
  created() {
    company
      .getAuditRecords(this, this.$store.state.userInfo.userId)
      .then(res => {
        if (res.success) {
          this.table_total = res.data.length;
          res.data.forEach(item => {
            if (item.auditResult == 1) {
              item.auditResult = "通过";
            } else {
              item.auditResult = "未通过";
            }
            this.tableData.push(item);
          });
        }
      });
  },
  mounted() {},
  methods: {
    // 当前页显示数量
    changeSizes(e) {
      console.log(e);
      this.pageSize = e;
    },
    // 当前页
    currentPage(e) {
      console.log(e);
    }
  }
};
</script>
<style lang="less" scoped>
.examineResult {
  min-height: 780px;
  position: relative;
  padding: 24px 0 81px;
  /deep/ .el-table thead {
    color: #43425d !important;
  }
  /deep/.el-table td,
  /deep/.el-table th.is-leaf {
    color: #43425d !important;
    text-align: center !important;
  }
  /deep/ .el-table thead tr th {
    text-align: center;
    background: #eaeaea !important;
  }
  .el-pagination {
    position: relative;
    top: 25px;
    display: inline-block;
    height: 30px;
    margin-left: 80px;
  }

  /deep/ .el-pager .number,
  /deep/ .btn-prev,
  /deep/ .btn-next {
    border: 1px solid #dcdcdc;
    color: #666666;
    font-size: 14px;
    margin: 0 5px;
    height: 30px;
    min-width: 30px;
    border-radius: 5px;

    &:hover {
      background: rgba(0, 0, 0, 0.2);
      color: #ffffff;
    }
  }

  /deep/ .el-pager .active {
    transition: all 0.3s;
    background: #2288f8;
    border: 1px solid #2288f8;
    color: #fff;

    &:hover {
      background: #2288f8;
      border: 1px solid #2288f8;
      color: #ffffff;
    }
  }

  /deep/.btn-next {
    padding-left: 8px;

    &:hover {
      background: #2288f8;
      border: 1px solid #2288f8;
      color: #ffffff;
    }
  }
  .bottom {
    position: absolute;
    bottom: 80px;
    height: 77px;
    width: 100%;
    padding-left: 15px;
    box-sizing: border-box;
    line-height: 77px;
    background: #e6e6e6;
    color: #707070;
    text-align: center;
  }
}
</style>